import { useState, useEffect } from 'react'
import { STORAGE_EVENT, storageService } from '../utils/storageService'

export function useLocalStorage(key) {
  const [value, setValue] = useState(() => localStorage.getItem(key))

  useEffect(() => {
    const handle = (e) => {
      const changedKey = e.key || e.detail?.key
      if (changedKey === key) {
        const newVal = e.detail?.value ?? localStorage.getItem(key)
        setValue(newVal)
      }
    }

    window.addEventListener('storage', handle)
    window.addEventListener(STORAGE_EVENT, handle)
    return () => {
      window.removeEventListener('storage', handle)
      window.removeEventListener(STORAGE_EVENT, handle)
    }
  }, [key])

  const setItem = (newVal, currTabEvent = true) => storageService.setItem(key, newVal, currTabEvent)
  const removeItem = (currTabEvent = true) => storageService.removeItem(key, currTabEvent)

  return [value, setItem, removeItem]
}

